import React from 'react';
import { motion } from 'framer-motion';
export const BonusSection = () => {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    num: 1,
    title: '10 Ganchos de Contenido',
    desc: 'Formatos listos para usar en Instagram y LinkedIn que atraen consultas.'
  }, {
    num: 2,
    title: 'Pack Reactivación de Muertos',
    desc: '25 mensajes probados para WhatsApp para ex-clientes y presupuestos fantasma.'
  }, {
    num: 3,
    title: 'Matriz de Oferta Anti-Crisis',
    desc: 'Plantilla para crear versiones básica, recomendada y premium de tu servicio.'
  }, {
    num: 4,
    title: 'Guion de Cierre Anti "No hay Plata"',
    desc: 'Guiones específicos para cerrar cuando el cliente dice "es caro" o "dejame pensarlo".'
  }];
  return <section className="py-24 bg-cream" data-id="element-13">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-16">
            Y eso es solo el manual. También recibís:
          </h2>
        </div>

        <div className="space-y-4" data-id="element-17">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={scrollToCompra} className="bg-white rounded-xl p-6 border border-neutral-200 shadow-sm cursor-pointer hover:border-brand-400 transition-colors group" data-id="element-18">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-19">
                <div className="flex items-start sm:items-center gap-4" data-id="element-20">
                  <span className="text-3xl" data-id="element-21">🎁</span>
                  <div data-id="element-22">
                    <h3 className="text-xl font-bold text-neutral-900 mb-1" data-id="element-23">
                      BONUS {bonus.num}: {bonus.title}
                    </h3>
                    <p className="text-neutral-600 m-0 text-sm sm:text-base" data-id="element-24">
                      {bonus.desc}
                    </p>
                  </div>
                </div>
                <div className="flex-shrink-0" data-id="element-25">
                  <span className="bg-brand-600 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider shadow-sm group-hover:bg-brand-700 transition-colors" data-id="element-26">
                    GRATIS HOY
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};